(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["clh-catalog-menu"] && !Shopify.designMode) return;
  try {
    document.addEventListener('pointerover', (event) => {
    if (event.pointerType !== 'mouse') return;
    const button = event.target.closest('.clh-catalog-tabs button[role="tab"]');
    if (!button || button.disabled || button.contains(event.relatedTarget)) return;
    const tabs = button.closest('tabs-element');
    tabs.querySelectorAll('[role="tab"]').forEach((tab) => tab.setAttribute('aria-selected', String(tab === button)));
    button.click();
  });
  document.addEventListener('click', (event) => {
    const button = event.target.closest('.clh-catalog-tabs button[role="tab"]');
    if (!button) return;
    button.closest('tabs-element').querySelectorAll('[role="tab"]').forEach((tab) => tab.setAttribute('aria-selected', String(tab === button)));
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["clh-classic-localization"] && !Shopify.designMode) return;
  try {
    document.addEventListener('change', event => {
  if (event.target.matches('[data-classic-language]')) event.target.form.requestSubmit();
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["clh-currency-picker"] && !Shopify.designMode) return;
  try {
    (() => {
  if (customElements.get('clh-fx-picker')) return;
  const supported = ['TWD','JPY','HKD','CNY','USD'];
  const read = key => { try { return localStorage.getItem(key); } catch { return null; } };
  const save = (key,value) => { try { localStorage.setItem(key,value); } catch {} };
  let currency = read('clh_reference_currency') || 'TWD';
  if (!supported.includes(currency)) currency = 'TWD';
  let rates;
  let request;
  const valid = data => data && data.result === 'success' && data.base_code === 'TWD' &&
    supported.every(code => Number.isFinite(data.rates?.[code]) && data.rates[code] > 0) &&
    Date.now()/1000 - data.time_last_update_unix < 172800;
  const ensureRates = async () => {
    if (rates) return rates;
    try {
      const cached = JSON.parse(read('clh_reference_rates'));
      if (valid(cached) && Date.now() < cached.time_next_update_unix*1000) return rates = cached;
    } catch {}
    if (!request) request = fetch('https://open.er-api.com/v6/latest/TWD', {credentials:'omit',referrerPolicy:'no-referrer',signal:AbortSignal.timeout(8000)})
      .then(response => { if (!response.ok) throw Error('rates'); return response.json(); })
      .then(data => { if (!valid(data)) throw Error('rates'); save('clh_reference_rates',JSON.stringify(data)); return rates=data; })
      .finally(() => { request=null; });
    return request;
  };
  const broadcast = () => document.dispatchEvent(new Event('clh:currency'));
  customElements.define('clh-fx-price', class extends HTMLElement {
    connectedCallback() {
      this.updateBound ||= this.update.bind(this);
      document.addEventListener('clh:currency',this.updateBound);
      this.update();
    }
    disconnectedCallback() { document.removeEventListener('clh:currency',this.updateBound); }
    async update() {
      this.hidden = true;
      const cents = Number(this.dataset.twd);
      if (currency === 'TWD' || !Number.isFinite(cents) || cents <= 0) return;
      try {
        const data = await ensureRates();
        if (currency === 'TWD' || !this.isConnected) return;
        const amount = cents/100 * data.rates[currency];
        const formatted = new Intl.NumberFormat(document.documentElement.lang || 'zh-TW',{maximumFractionDigits:currency==='JPY'?0:2,minimumFractionDigits:0}).format(amount);
        this.textContent = '≈ ' + currency + ' ' + formatted;
        this.title = new Date(data.time_last_update_unix*1000).toLocaleDateString() + ' · ' + this.dataset.note;
        this.hidden = false;
      } catch {}
    }
  });
  customElements.define('clh-fx-picker', class extends HTMLElement {
    connectedCallback() {
      const select=this.querySelector('select');
      const status=this.querySelector('[data-fx-status]');
      const help=this.querySelector('[data-fx-help]');
      const info=this.querySelector('[popover]');
      const place=()=>{
        if(!info.matches(':popover-open')) return;
        const rect=help.getBoundingClientRect();
        const viewport=window.visualViewport;
        const left=viewport?.offsetLeft||0, top=viewport?.offsetTop||0;
        const width=viewport?.width||window.innerWidth, height=viewport?.height||window.innerHeight;
        info.style.maxWidth=Math.max(0,width-32)+'px';
        info.style.maxHeight=Math.max(0,height-32)+'px';
        const box=info.getBoundingClientRect();
        const x=Math.min(Math.max(left+16,rect.right-box.width),left+width-box.width-16);
        const y=rect.top-top>box.height+16?rect.top-box.height-10:Math.min(rect.bottom+10,top+height-box.height-16);
        info.style.left=x+'px';info.style.top=Math.max(top+16,y)+'px';
      };
      this.openHelp=()=>{if(!info.matches(':popover-open')) info.showPopover();place();};
      help.onclick=()=>requestAnimationFrame(place);
      info.addEventListener('toggle',()=>{const open=info.matches(':popover-open');help.setAttribute('aria-expanded',String(open));if(open)place();});
      this.placeHelp=place;
      window.addEventListener('resize',place);
      window.addEventListener('scroll',place,true);
      const sync=()=>{select.value=currency;};
      this.sync=sync;
      document.addEventListener('clh:currency',sync);
      sync();
      select.addEventListener('change',async()=>{
        const next=select.value;
        select.disabled=true;
        try {
          if(next!=='TWD') await ensureRates();
          currency=next;
          save('clh_reference_currency',currency);
          status.textContent='';
          broadcast();
        } catch {
          sync();
          status.textContent=this.dataset.error;
          this.openHelp();
        } finally {select.disabled=false;}
      });
    }
    disconnectedCallback(){document.removeEventListener('clh:currency',this.sync);window.removeEventListener('resize',this.placeHelp);window.removeEventListener('scroll',this.placeHelp,true);}
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["clh-play-logo"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('clhp-brand')) {
  customElements.define('clhp-brand', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const signal = this.controller.signal;
      const button = this.querySelector('.clhp-logo__toggle');
      const sync = () => this.toggleAttribute('data-hidden', document.hidden);
      sync();
      document.addEventListener('visibilitychange', sync, {signal});
      button?.addEventListener('click', () => {
        const paused = this.toggleAttribute('data-paused');
        button.setAttribute('aria-pressed', String(paused));
      }, {signal});
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["clh-store-filter"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('clh-store-filter')) {
    customElements.define('clh-store-filter', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        if (this.dataset.search === 'true') {
          const selected = new URL(window.location.href).searchParams.get('clh_store') || '';
          this.querySelectorAll('[data-store-tag]').forEach(input => { input.checked = input.value === selected; });
        }
        this.addEventListener('change', (event) => {
          if (!event.target.matches('[data-store-tag]')) return;
          const storeTags = ['高雄店', '台北店'];
          const selected = event.target.value;
          if (this.dataset.search === 'true') {
            const url = new URL(window.location.href);
            const query = (url.searchParams.get('q') || '').replace(/ AND tag:"(高雄店|台北店)"$/, '');
            url.searchParams.set('q', query + (selected ? ' AND tag:"' + selected + '"' : ''));
            if (selected) url.searchParams.set('clh_store', selected);
            else url.searchParams.delete('clh_store');
            url.searchParams.delete('page');
            url.searchParams.delete('section_id');
            url.searchParams.delete('filter.p.tag');
            window.location.assign(url.href);
            return;
          }
          const currentTags = JSON.parse(this.dataset.tags || 'null') || [];
          const remainingTags = currentTags.filter(tag => !storeTags.includes(tag));
          if (selected) remainingTags.push(selected);
          const url = new URL(this.dataset.baseUrl, window.location.origin);
          if (remainingTags.length) url.pathname += '/' + remainingTags.map(encodeURIComponent).join('+');
          url.search = window.location.search;
          for (const key of [...url.searchParams.keys()]) {
            if (key === 'page' || key.startsWith('filter.')) url.searchParams.delete(key);
          }
          window.location.assign(url.href);
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["header-nav-drawer"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('clh-scroll-cue'))customElements.define('clh-scroll-cue',class extends HTMLElement{
 connectedCallback(){
  const area=this.querySelector('[data-clh-scroll-area]'),button=this.querySelector('[data-clh-more]');
  if(!area||!button)return;
  this.update=()=>{button.hidden=area.clientHeight<1||area.scrollHeight-area.clientHeight-area.scrollTop<12;};
  area.addEventListener('scroll',this.update,{passive:true});
  button.onclick=()=>area.scrollBy({top:Math.max(160,area.clientHeight*.65),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
  this.observer=new ResizeObserver(this.update);this.observer.observe(area);if(area.firstElementChild)this.observer.observe(area.firstElementChild);
  this.frame=requestAnimationFrame(this.update);
 }
 disconnectedCallback(){this.querySelector('[data-clh-scroll-area]')?.removeEventListener('scroll',this.update);this.observer?.disconnect();cancelAnimationFrame(this.frame);}
});
  } catch(e) { console.error(e); }
})();

})();
